import { deepNullToUndefined } from '~src/util';

import { FetchProductParameters } from './model';
import { useFetchHeatPumpIndoorUnits, useFetchHeatPumpOutdoorUnits } from './useHeatPump';

type FetchOptions = { include?: boolean; limit?: number };

export const useFetchProducts = (
  parameters: FetchProductParameters = {},
  outdoorUnitOptions?: FetchOptions,
  indoorUnitOptions?: FetchOptions
) => {
  const { pause } = parameters;

  const { include: includeOutdoorUnits = true } = outdoorUnitOptions ?? {};
  const { include: includeIndoorUnits = true } = indoorUnitOptions ?? {};

  const { data: outdoorUnits = [] } =
    useFetchHeatPumpOutdoorUnits({
      ...parameters,
      pause: pause || !includeOutdoorUnits,
    }) ?? {};

  const { data: indoorUnits = [] } =
    useFetchHeatPumpIndoorUnits({
      ...parameters,
      pause: pause || !includeIndoorUnits,
    }) ?? {};

  return {
    outdoorUnits: outdoorUnits.map(deepNullToUndefined),
    indoorUnits: indoorUnits.map(deepNullToUndefined),
  };
};
